/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from 'relay-runtime';
export type QrCodeType = 'REDIRECT' | 'URL' | 'WIFI' | '%future added value';
export type WifiEncryptionType = 'NONE' | 'WEP' | 'WPA' | '%future added value';
export type WifiForm_qrCode = {
  readonly type: QrCodeType;
  readonly isDynamic: boolean;
  readonly name: string | null;
  readonly ssid?: string | null;
  readonly password?: string | null;
  readonly encryption?: WifiEncryptionType | null;
  readonly ' $refType': 'WifiForm_qrCode';
};
export type WifiForm_qrCode$data = WifiForm_qrCode;
export type WifiForm_qrCode$key = {
  readonly ' $data'?: WifiForm_qrCode$data;
  readonly ' $fragmentRefs': FragmentRefs<'WifiForm_qrCode'>;
};

const node: ReaderFragment = {
  argumentDefinitions: [],
  kind: 'Fragment',
  metadata: null,
  name: 'WifiForm_qrCode',
  selections: [
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'type',
      storageKey: null,
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'isDynamic',
      storageKey: null,
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'name',
      storageKey: null,
    },
    {
      kind: 'InlineFragment',
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'ssid',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'password',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'encryption',
          storageKey: null,
        },
      ],
      type: 'WifiQrCode',
    },
  ],
  type: 'QrCode',
};
(node as any).hash = '8c39220765337336c77d3fcc89bcc100';
export default node;
